import { createFeatureSelector, createSelector } from '@ngrx/store';

import { StandardDonationState } from './standard-donation.reducers';

export const standardDonationFeatureStateSelector = createFeatureSelector<StandardDonationState>('standardDonation');

export const selectStandardDonations = createSelector(
  standardDonationFeatureStateSelector,
  (state: StandardDonationState) => state.standardDonations,
);
export const selectStandardDonationsTotalCount = createSelector(
  standardDonationFeatureStateSelector,
  (state: StandardDonationState) => state.standardDonationsTotalCount,
);
export const selectStandardDonation = createSelector(
  standardDonationFeatureStateSelector,
  (state: StandardDonationState) => state.standardDonation,
);
